import React, { useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from 'src/redux';
import { useEmojisplosion } from 'src/hooks';
import { useSearchParams } from 'react-router-dom';

import { Box, Typography } from '@mui/material';
import {
  BrandLogo,
  Loader,
  PageWrapper,
  StepPanelHeader,
} from '../../components';
import LetsConnect from 'src/features/letsConnect/LetsConnect';

import {
  confirmCandidatePositionSubscription,
  positionSubscriptionSelectors,
} from 'src/redux/positionSubscription';

import starImage from 'src/assets/passing-star.png';
import { isStatusIdle, isStatusLoading } from 'src/utils';

export const PositionSubscriptionEmailConfirmed: React.FC = () => {
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();

  const confirmPositionSubscriptionAPIStatus = useAppSelector(
    positionSubscriptionSelectors.getConfirmSubscriptionAPIStatus,
  );
  const { data: subscriptionDetails } = useAppSelector(
    positionSubscriptionSelectors.getSubscriptionDetailsAPIData,
  );

  const starRef = useRef<HTMLDivElement>(null);
  useEmojisplosion(starRef, 'DEFAULT');

  const token = searchParams.get('token');

  useEffect(() => {
    if (token) {
      dispatch(confirmCandidatePositionSubscription(token));
    }
  }, []);

  if (
    isStatusLoading(confirmPositionSubscriptionAPIStatus) ||
    isStatusIdle(confirmPositionSubscriptionAPIStatus)
  ) {
    return (
      <PageWrapper>
        <Loader showBrandLogo />
      </PageWrapper>
    );
  }

  if (!subscriptionDetails) {
    return (
      <PageWrapper>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'absolute',
            width: '100%',
            height: '100%',
          }}
          data-testid="is-loading"
        >
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              m: 6,
            }}
          >
            <BrandLogo />
          </Box>
          <Typography variant="h6" fontWeight="600" textAlign="center">
            Subscription not found
          </Typography>
        </Box>
      </PageWrapper>
    );
  }

  return (
    <Box
      sx={(theme) => ({
        background: theme.palette.background.backgroundPrimary,
        minWidth: '100%',
        minHeight: '100%',
        padding: '41px 16px',
        [theme.breakpoints.down('lg')]: {
          paddingTop: '130px',
        },
      })}
    >
      <Box sx={{ position: 'absolute', top: '49px', left: '66px' }}>
        <BrandLogo width={133} />
      </Box>
      <Box display="flex" alignItems="center" flexDirection="column">
        <Box
          sx={(theme) => ({
            background: theme.palette.common.white,
            padding: '110px 100px',
            borderRadius: '48px',
            maxWidth: '624px',
            position: 'relative',
          })}
        >
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
          >
            <StepPanelHeader ref={starRef} srcSetPng={starImage} alt="Star">
              Thanks for staying with us
            </StepPanelHeader>

            <Typography variant="body1" textAlign="center" my={4}>
              We’ll keep you posted with new positions matching your profile.
            </Typography>

            <LetsConnect withHeader={false} />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
